import React, { useState } from 'react';

const Order: React.FC = () => {
  const [orderStep, setOrderStep] = useState(1);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
    paymentMethod: 'card',
    cardNumber: '',
    expiryDate: '',
    cvv: '',
    nameOnCard: ''
  });

  const cartItems = [
    {
      id: 1,
      title: "Golden Autumn - Textured Nature Abstract Painting",
      artist: "Maulik Vasani",
      price: 1400.00,
      size: "104 x 104 cm",
      image: "product_grid_img_1.png",
      quantity: 1
    },
    {
      id: 2,
      title: "Abstract Dreams",
      artist: "Sarah Johnson",
      price: 850.00,
      size: "80 x 80 cm",
      image: "product_grid_img_2.png",
      quantity: 1
    }
  ];

  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const total = subtotal; // No tax or shipping charges

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleNextStep = () => {
    if (orderStep < 3) {
      setOrderStep(orderStep + 1);
    }
  };

  const handlePrevStep = () => {
    if (orderStep > 1) {
      setOrderStep(orderStep - 1);
    }
  };

  const handleSubmitOrder = () => {
    // Handle order submission
    console.log('Order submitted:', formData);
    setOrderStep(4); // Success step
  };

  return (
    <div>
      {/* Order Banner Section */}
      <section className="order_banner_section" id="order_banner">
        <div className="common_banner_section" id="common_banner_sec">
          <div className="page_navegation_area">
            <div className="container">
              <div className="page_navegation font_two">
                <p><a href="/">Home</a> / <a href="/products?collection=Canvas">Products</a> / <span className="active fw_700">Order</span></p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Order Process Section */}
      <section className="order_process_section">
        <div className="order_process_sec">
          <div className="container">
            <div className="order_process_area">
              {/* Progress Steps */}
              <div className="order_progress_area">
                <div className="progress_steps">
                  <div className={`step ${orderStep >= 1 ? 'active' : ''}`}>
                    <div className="step_number">1</div>
                    <div className="step_title">Shipping Info</div>
                  </div>
                  <div className={`step ${orderStep >= 2 ? 'active' : ''}`}>
                    <div className="step_number">2</div>
                    <div className="step_title">Payment</div>
                  </div>
                  <div className={`step ${orderStep >= 3 ? 'active' : ''}`}>
                    <div className="step_number">3</div>
                    <div className="step_title">Review</div>
                  </div>
                  <div className={`step ${orderStep >= 4 ? 'active' : ''}`}>
                    <div className="step_number">4</div>
                    <div className="step_title">Complete</div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-8">
                  <div className="order_form_area">
                    {orderStep === 1 && (
                      <div className="shipping_info_step">
                        <h2 className="step_title">Shipping Information</h2>
                        <form className="shipping_form">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form_group">
                                <label htmlFor="firstName">First Name *</label>
                                <input
                                  type="text"
                                  id="firstName"
                                  name="firstName"
                                  value={formData.firstName}
                                  onChange={handleInputChange}
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form_group">
                                <label htmlFor="lastName">Last Name *</label>
                                <input
                                  type="text"
                                  id="lastName"
                                  name="lastName"
                                  value={formData.lastName}
                                  onChange={handleInputChange}
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form_group">
                                <label htmlFor="email">Email Address *</label>
                                <input
                                  type="email"
                                  id="email"
                                  name="email"
                                  value={formData.email}
                                  onChange={handleInputChange}
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form_group">
                                <label htmlFor="phone">Phone Number</label>
                                <input
                                  type="tel"
                                  id="phone"
                                  name="phone"
                                  value={formData.phone}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form_group">
                                <label htmlFor="address">Street Address *</label>
                                <input
                                  type="text"
                                  id="address"
                                  name="address"
                                  value={formData.address}
                                  onChange={handleInputChange}
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form_group">
                                <label htmlFor="city">City *</label>
                                <input
                                  type="text"
                                  id="city"
                                  name="city"
                                  value={formData.city}
                                  onChange={handleInputChange}
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form_group">
                                <label htmlFor="state">State/Province *</label>
                                <input
                                  type="text"
                                  id="state"
                                  name="state"
                                  value={formData.state}
                                  onChange={handleInputChange}
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form_group">
                                <label htmlFor="zipCode">ZIP/Postal Code *</label>
                                <input
                                  type="text"
                                  id="zipCode"
                                  name="zipCode"
                                  value={formData.zipCode}
                                  onChange={handleInputChange}
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form_group">
                                <label htmlFor="country">Country *</label>
                                <select
                                  id="country"
                                  name="country"
                                  value={formData.country}
                                  onChange={handleInputChange}
                                  required
                                >
                                  <option value="">Select Country</option>
                                  <option value="US">United States</option>
                                  <option value="CA">Canada</option>
                                  <option value="UK">United Kingdom</option>
                                  <option value="AU">Australia</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}

                    {orderStep === 2 && (
                      <div className="payment_info_step">
                        <h2 className="step_title">Payment Information</h2>
                        <form className="payment_form">
                          <div className="payment_methods">
                            <div className="payment_method">
                              <input
                                type="radio"
                                id="card"
                                name="paymentMethod"
                                value="card"
                                checked={formData.paymentMethod === 'card'}
                                onChange={handleInputChange}
                              />
                              <label htmlFor="card">Credit/Debit Card</label>
                            </div>
                            <div className="payment_method">
                              <input
                                type="radio"
                                id="paypal"
                                name="paymentMethod"
                                value="paypal"
                                checked={formData.paymentMethod === 'paypal'}
                                onChange={handleInputChange}
                              />
                              <label htmlFor="paypal">PayPal</label>
                            </div>
                          </div>

                          {formData.paymentMethod === 'card' && (
                            <div className="card_details">
                              <div className="form_group">
                                <label htmlFor="cardNumber">Card Number *</label>
                                <input
                                  type="text"
                                  id="cardNumber"
                                  name="cardNumber"
                                  value={formData.cardNumber}
                                  onChange={handleInputChange}
                                  placeholder="1234 5678 9012 3456"
                                  required
                                />
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form_group">
                                    <label htmlFor="expiryDate">Expiry Date *</label>
                                    <input
                                      type="text"
                                      id="expiryDate"
                                      name="expiryDate"
                                      value={formData.expiryDate}
                                      onChange={handleInputChange}
                                      placeholder="MM/YY"
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form_group">
                                    <label htmlFor="cvv">CVV *</label>
                                    <input
                                      type="text"
                                      id="cvv"
                                      name="cvv"
                                      value={formData.cvv}
                                      onChange={handleInputChange}
                                      placeholder="123"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="form_group">
                                <label htmlFor="nameOnCard">Name on Card *</label>
                                <input
                                  type="text"
                                  id="nameOnCard"
                                  name="nameOnCard"
                                  value={formData.nameOnCard}
                                  onChange={handleInputChange}
                                  required
                                />
                              </div>
                            </div>
                          )}
                        </form>
                      </div>
                    )}

                    {orderStep === 3 && (
                      <div className="review_step">
                        <h2 className="step_title">Review Your Order</h2>
                        <div className="order_summary">
                          <h3>Order Summary</h3>
                          <div className="order_items">
                            {cartItems.map((item) => (
                              <div key={item.id} className="order_item">
                                <div className="item_image">
                                  <img src={`/assets/images/${item.image}`} alt={item.title} />
                                </div>
                                <div className="item_details">
                                  <h4>{item.title}</h4>
                                  <p>By {item.artist}</p>
                                  <p>Size: {item.size}</p>
                                  <p>Quantity: {item.quantity}</p>
                                </div>
                                <div className="item_price">
                                  ${(item.price * item.quantity).toFixed(2)}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}

                    {orderStep === 4 && (
                      <div className="success_step">
                        <div className="success_content text-center">
                          <div className="success_icon">
                            <img src="/assets/images/order-conform-img.png" alt="Order Confirmed" />
                          </div>
                          <h2>Order Confirmed!</h2>
                          <p>Thank you for your purchase. You will receive an email confirmation shortly.</p>
                          <div className="success_actions">
                            <a href="/products?collection=Canvas" className="arrow_btn_one">
                              <span className="btn_text">Continue Shopping</span>
                              <span className="btn_icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <path d="M17.9998 6H18.7498V5.25H17.9998V6ZM17.9998 6L17.4695 5.46967L5.46967 17.4697L6 18L6.53033 18.5303L18.5301 6.53033L17.9998 6ZM10.9999 6V6.75H17.9998V6V5.25H10.9999V6ZM17.9998 6H17.2498V12.9999H17.9998H18.7498V6H17.9998Z" fill="#E7D5AD"/>
                                </svg>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    )}

                    {orderStep < 4 && (
                      <div className="step_actions">
                        {orderStep > 1 && (
                          <button className="prev_btn arrow_btn_two" onClick={handlePrevStep}>
                            <span className="btn_text">Previous</span>
                            <span className="btn_icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M17.9998 6H18.7498V5.25H17.9998V6ZM17.9998 6L17.4695 5.46967L5.46967 17.4697L6 18L6.53033 18.5303L18.5301 6.53033L17.9998 6ZM10.9999 6V6.75H17.9998V6V5.25H10.9999V6ZM17.9998 6H17.2498V12.9999H17.9998H18.7498V6H17.9998Z" fill="#112C3B"/>
                              </svg>
                            </span>
                          </button>
                        )}
                        {orderStep < 3 ? (
                          <button className="next_btn arrow_btn_one" onClick={handleNextStep}>
                            <span className="btn_text">Next</span>
                            <span className="btn_icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M17.9998 6H18.7498V5.25H17.9998V6ZM17.9998 6L17.4695 5.46967L5.46967 17.4697L6 18L6.53033 18.5303L18.5301 6.53033L17.9998 6ZM10.9999 6V6.75H17.9998V6V5.25H10.9999V6ZM17.9998 6H17.2498V12.9999H17.9998H18.7498V6H17.9998Z" fill="#E7D5AD"/>
                              </svg>
                            </span>
                          </button>
                        ) : (
                          <button className="place_order_btn arrow_btn_one" onClick={handleSubmitOrder}>
                            <span className="btn_text">Place Order</span>
                            <span className="btn_icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M17.9998 6H18.7498V5.25H17.9998V6ZM17.9998 6L17.4695 5.46967L5.46967 17.4697L6 18L6.53033 18.5303L18.5301 6.53033L17.9998 6ZM10.9999 6V6.75H17.9998V6V5.25H10.9999V6ZM17.9998 6H17.2498V12.9999H17.9998H18.7498V6H17.9998Z" fill="#E7D5AD"/>
                              </svg>
                            </span>
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="order_summary_sidebar">
                    <div className="summary_card">
                      <h3>Order Summary</h3>
                      <div className="summary_items">
                        {cartItems.map((item) => (
                          <div key={item.id} className="summary_item">
                            <div className="item_info">
                              <h4>{item.title}</h4>
                              <p>By {item.artist}</p>
                              <p>Size: {item.size}</p>
                              <p>Qty: {item.quantity}</p>
                            </div>
                            <div className="item_price">
                              ${(item.price * item.quantity).toFixed(2)}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="summary_totals">
                        <div className="total_line">
                          <span>Subtotal:</span>
                          <span>${subtotal.toFixed(2)}</span>
                        </div>
                        <div className="total_line total">
                          <span>Total:</span>
                          <span>${total.toFixed(2)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Order;
